__turbopack_context__.v({
  "body": "LMsLDq_body",
  "copy": "LMsLDq_copy",
  "cta": "LMsLDq_cta",
  "heading": "LMsLDq_heading",
  "panel": "LMsLDq_panel",
});
